import './Impact.css';

const stats = [
  { number: '3', label: 'Operating Businesses' },
  { number: '200+', label: 'Jobs Created' },
  { number: '450+', label: 'Farmer Network' },
  { number: '₹ 2 Cr+', label: 'Rural Wages Disbursed' },
];

export default function Impact() {
  return (
    <section className="impact">
      <div className="impact-bg">
        <img src="/images/farm_plant_1.jpg" alt="Farm" />
        <div className="impact-overlay" />
      </div>
      <div className="impact-inner">
        <div className="impact-header">
          <p className="section-label" style={{ color: 'var(--terracotta-light)' }}>Our Footprint</p>
          <h2 className="section-title light">By the numbers.</h2>
        </div>
        <div className="impact-stats">
          {stats.map(s => (
            <div className="stat-card" key={s.label}>
              <span className="stat-number">{s.number}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
